import React from "react";
import { Form, Input } from "antd";
import inputStyles from "../../../../styles/Custom/Input.module.css";

const Comments = ({ form }) => {
  return (
    <div>
      <Form.Item name={["comments", "comments"]}>
        <Input className={inputStyles.mdInput} style={{ width: "100%" }} />
      </Form.Item>
    </div>
  );
};

export default Comments;
